import React, { Component } from "react";
import ReactDOM from "react-dom";
import workflowUtil from "../util/workflowUtil";

class UpdatedPaymentRequired extends Component {
	
	componentDidMount() {
		window.$(ReactDOM.findDOMNode(this)).modal("show");
		window.$(ReactDOM.findDOMNode(this)).on("hidden.bs.modal", this.props.modalHidden)
		// bootstrap puts a blur on ".modal-open .page-wrapper" and recommends placing modals in a top-level to prevent
		// other CSS from affecting the modal appearance. We can't do this though, because the react root is nested
		// pretty deep in the wrapping DOM, so instead we're programatically dropping the blurry styles
		window.$(".page-wrapper").css({
			"filter": "none",
			"-webkit-filter": "none",
			"-moz-filter": "none",
			"-o-filter": "none",
			"-ms-filter": "none"
		});
	}

	render() {
		/*
		 * Get the most recently completed Panels or Billing Options step.
		 * If that step was saved by the client, include "provider" wording.
		 */
		const panelStep = this.props.gearOrder?.workflow?.steps?.find(
			(step) => step.id === workflowUtil.workflowMetaData.panel.id && step.completed
		);
		const billingStep = this.props.gearOrder?.workflow?.steps?.find(
			(step) => step.id === workflowUtil.workflowMetaData.billing.id && step.completed
		);

		let changesFromProvider = false;
		if (panelStep?.stepDate) {
			changesFromProvider = panelStep.userType === 'myGDX';
		}
		if (billingStep?.stepDate) {
			if (panelStep?.stepDate) {
				// Compare dates and find latest step
				const mostRecentStep =
					Date.parse(panelStep.stepDate) > Date.parse(billingStep.stepDate) ? panelStep : billingStep;
				changesFromProvider = mostRecentStep?.userType === 'myGDX';
			} else {
				changesFromProvider = billingStep.userType === 'myGDX';
			}
		}

		let text = (
			<div>
				<p>
					Based on recent order updates{changesFromProvider && ' made by your provider'}, the payment amount
					due today has been revised. In order to ensure that your order is processed successfully, we kindly
					request that you update your authorized payment details below.
				</p>
				{changesFromProvider && (
					<p>
						While we cannot directly modify or speak to the changes made by your provider, we strongly
						encourage you to reach out to them with any questions or concerns that you may have. By doing
						so, you will receive the answers and information that you need to make informed decisions
						regarding your lab testing.
					</p>
				)}
			</div>
		);

		return (
			<div className="modal fade" id="updatedPaymentRequiredModal" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">Updated Payment Information Required</h4>
						</div>
						<div className="modal-body">{text}</div>
						<div className="modal-footer">
							<button type="button" className="btn" data-dismiss="modal">
								Close
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default UpdatedPaymentRequired;
